import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { GeneratedDocumentOriginSchema, GeneratedDocumentTypeSchema } from '../deal/deal-documents.schemas';

const GeneratedDocumentEventBase = z.object({
  generatedDocumentId: z.uuid(),
  dealId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  propertyId: z.uuid(),
  documentType: GeneratedDocumentTypeSchema,
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export const GeneratedDocumentRequestedPayloadSchema = GeneratedDocumentEventBase.extend({
  origin: GeneratedDocumentOriginSchema,
  retryOfDocumentId: z.uuid().nullable(),
});
export type GeneratedDocumentRequestedPayload = z.infer<typeof GeneratedDocumentRequestedPayloadSchema>;

export const GeneratedDocumentCompletedPayloadSchema = GeneratedDocumentEventBase.extend({
  templateName: z.string(),
  manuallyAdjusted: z.boolean(),
  fileName: z.string(),
  propertyDocumentId: z.uuid().nullable(),
});
export type GeneratedDocumentCompletedPayload = z.infer<typeof GeneratedDocumentCompletedPayloadSchema>;

export const GeneratedDocumentFailedPayloadSchema = GeneratedDocumentEventBase;
export type GeneratedDocumentFailedPayload = z.infer<typeof GeneratedDocumentFailedPayloadSchema>;

export const GeneratedDocumentOriginalReceivedChangedPayloadSchema = GeneratedDocumentEventBase.extend({
  received: z.boolean(),
  receivedAt: z.iso.datetime().nullable(), // the server time when received; null when cleared
});
export type GeneratedDocumentOriginalReceivedChangedPayload = z.infer<
  typeof GeneratedDocumentOriginalReceivedChangedPayloadSchema
>;

export const GeneratedDocumentDeletedPayloadSchema = GeneratedDocumentEventBase.extend({ fileName: z.string() });
export type GeneratedDocumentDeletedPayload = z.infer<typeof GeneratedDocumentDeletedPayloadSchema>;
